import React, { useMemo } from 'react';
import { NumericFormat } from 'react-number-format';
import { Input } from './input';
import { useCurrency } from '../../contexts/Currency';
import { getCurrencyParts } from '../../Utils/locale';

const CurrencyInput = ({ value, onValueChange, currency: currencyProp, ...rest }) => {
  const ctx = useCurrency();

  const activeParts = useMemo(
    () => (currencyProp ? getCurrencyParts(currencyProp) : ctx.parts),
    [currencyProp, ctx.parts]
  );

  const { prefix, suffix, thousandSeparator, decimalSeparator, decimalScale } = activeParts;

  return (
    <NumericFormat
      customInput={Input}
      prefix={prefix}
      suffix={suffix}
      thousandSeparator={thousandSeparator || false}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      fixedDecimalScale={true}
      allowNegative={false}
      value={value}
      onValueChange={(values) => {
        onValueChange(values.floatValue);
      }}
      {...rest}
    />
  );
};

export { CurrencyInput };
